(function() { window.GUID_7735cd96_62ff_4b20_9c4d_98d3b6df62dd = { getGuid: function() { return "7735cd96-62ff-4b20-9c4d-98d3b6df62dd"; } }; })();
var Register;
(function (Register) {
    let firstName = $('#FirstName');
    let lastName = $('#LastName');
    let email = $('#Email');
    let password = $('#Password');
    let newPassword = $('#NewPassword');
    let confirmPassword = $('#ConfirmPassword');
    let timerPassword = null;
    let passwordValidationResult = $('#PasswordValidationResult');
    firstName.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    lastName.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    email.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    password.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    newPassword.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    confirmPassword.on('keyup', function () {
        PreValidatePasswordStrenght();
    });
    function PreValidatePasswordStrenght() {
        if (password.length == 0 || password.val().length == 0) {
            return;
        }
        if (timerPassword != null) {
            clearTimeout(timerPassword);
        }
        timerPassword = setTimeout(function () {
            let data = {
                firstName: firstName.val(),
                lastName: lastName.val(),
                email: email.val(),
                password: password.val(),
                confirmPassword: confirmPassword.val()
            };
            CompuSport.Ajax.Get(CSParameters.RUrl + "Account/PreValidatePasswordStrength/0", data, function (queryResult) {
                passwordValidationResult.html(queryResult);
            });
        }, 500);
    }
})(Register || (Register = {}));

//# sourceMappingURL=Register.js.map
